export default class Frame {
  get id() { return this._id }
  
  _id: string;
  order: number;

  activePath: Array<[number, number]>;
  paths: Array<Array<[number, number]>>;

  constructor(paths = [], activePath = null) {
    this._id = crypto.getRandomValues(new Uint16Array(4)).join('-');
    this.paths = paths;
    this.activePath = activePath;
  }

  clone() {
    const clone = new Frame();
    clone.paths = this.paths.map(path => path.map(point => point.map(v => v))) as Array<Array<[number, number]>>;
    return clone;
  }

  beginPath(point) {
    this.activePath = [point];
    this.paths.push(this.activePath);
  }

  lineTo(point) {
    this.activePath.push(point);
  }

  endPath(point?:[number, number]) {
    if (!point && this.activePath.length) {
      return this.activePath[this.activePath.length - 1];
    }
    
    if (this.activePath.length < 1) this.paths.pop();
    
    return this.activePath.push(point);
  }

  addPath(path: Array<[number, number]>) {
    this.activePath = path;
    this.paths.push(path);
  }

  destroy() {
    this.activePath = undefined;
    this.paths = undefined;
  }

  toJSON() {
    return {
      paths: this.paths,
      activePath: this.activePath
    };
  }
}